import { DateUtil, isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { AbstractModel } from './abstract-model';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { RideRequestLocation } from './ride-request-location';
import { RideRequestType } from './ride-request-type';
import { ServiceLevel } from './service-level';

@inheritSerialization(AbstractModel)
export class RideSubscriptionLeg extends AbstractModel {
  @autoserialize
  rideSubscriptionId: number;

  @autoserializeAs(Date)
  pickupTime: Date;

  @autoserializeAs(RideRequestLocation)
  pickupLocation: RideRequestLocation;

  @autoserializeAs(Date)
  dropoffTime: Date;

  @autoserializeAs(RideRequestLocation)
  dropoffLocation: RideRequestLocation;

  @autoserializeAs(RideRequestType)
  rideRequestType: RideRequestType;

  @autoserialize
  riderNote: string;

  @autoserialize
  timezone: string;

  @autoserializeAs(ServiceLevel)
  serviceLevel: ServiceLevel;

  static OnSerialized(instance: RideSubscriptionLeg, json: any): void {
    super.OnSerialized(instance, json);
    if (!isNullOrUndefined(instance.pickupTime)) {
      json.pickupTime = DateUtil.serializeLocalTime(instance.pickupTime);
    }
    if (!isNullOrUndefined(instance.dropoffTime)) {
      json.dropoffTime = DateUtil.serializeLocalTime(instance.dropoffTime);
    }
  }

  static OnDeserialized(instance: RideSubscriptionLeg, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['pickupTime'])) {
      instance.pickupTime = DateUtil.deserializeLocalTime(json['pickupTime']);
    }

    if (!isNullOrUndefined(json['dropoffTime'])) {
      instance.dropoffTime = DateUtil.deserializeLocalTime(json['dropoffTime']);
    }
  }
}
